export const PopupTypes = {
    ShortReservation: 1001
}

export const icons = [
    {
        "color": "#38bbf7",
        "items": [
            {
                "title": "ReservationSearch",
                "icon": "icon-search-in-folder",
                "url": "PMS/Reservations/Search",
                "mobile": true
            },
            {
                "title": "NewReservation",
                "icon": "icon-file",
                "url": "PMS/Reservations/Index",
                "mobile": true
            },
            {
                "title": "ShortReservation",
                "icon": "icon-edit",
                "externalSystemID": PopupTypes.ShortReservation,
                "mobile": true
            },
            {
                "title": "GroupReservation",
                "icon": "icon-multiple-users-silhouette",
                "url": "PMS/ReservationGroupDataService/ReservationGroup"
            }
        ]
    },
    {
        "color": "#cf1b58",
        "items": [
            {
                "title": "Customers",
                "icon": "icon-users-1",
                "url": "CRM/Customers/Customers"
            },
            {
                "title": "CRM",
                "icon": "icon-masculine-avatar-user-with-suit",
                "url": "CRM/Guest/SearchGuests",
                "mobile": true
            }
        ]
    },
    {
        "color": "#FF9800",
        "items": [
            {
                "title": "GuestInHouse",
                "icon": "icon-keychain-with-key",
                "url": "PMS/Reservations/GuestInHouse?gin=true"
            },{
                "title": "Arrivals",
                "icon": "icon-hotel-reception-bell",
                "url": "PMS/Reservations/Arrivals"
            },{
                "title": "Housekeeping",
                "icon": "icon-wiping-swipe-for-floors",
                "url": "PMS/HotelHousekeeping/Index",
                "mobile": true
            },{
                "title": "Calendar",
                "icon": "icon-analysis-chart",
                "url": "PMS/TapeChart/Calendar",
                "mobile": true
            }
        ]
    },{
        "color": "#01A7BD",
        "items": [
            {
                "title": "Availability",
                "icon": "icon-calendar",
                "url": "PMS/HotelAvailability/Index/#/monthly/"
            },{
                "title": "Restriction",
                "icon": "icon-do-not-disturbe",
                "url": "PMS/Restriction/Index/"
            },{
                "title": "Rate",
                "icon": "icon-dollar-symbol-2",
                "url": "PMS/RateInternal/rates/"
            },{
                "title": "OptimaLive",
                "icon": "icon-sun",
                "url": "PMS/Live/Index",
                "mobile": true
            }
        ]
    },{
        "color": "#8BC34A",
        "items": [
            {
                "title": "FoliosSearch",
                "icon": "icon-money-finder",
                "url": "Finance/Folio/FolioSearch"
            },{
                "title": "CurrencyExchange",
                "icon": "icon-currency-exchange",
                "url": "Finance/currency/CurrencyExchange"
            },{
                "title": "OptimaShop",
                "icon": "icon-shopping-cart2",
                "url": "Finance/Folio/Folio?DailyFolio=true"
            }
        ]
    },{
        "color": "#8b239d",
        "items": [
            {
                "title": "ChannelManager",
                "icon": "icon-business-affiliate-network",
                "url": "",
                "externalSystemID": 1,
                "connector": () => {
                    window.optima.utils.ConnectToChannelManager()
                }
            },{
                "title": "Dashboard",
                "icon": "grid layout",
                "url": "Home/Dashboard",
                "mobile": true
            },{
                "title": "Reports",
                "icon": "icon-document-with-line-chart",
                "url": "SharedServices/Control/Report"
            },{
                "title": "AnalyticsReports",
                "icon": "icon-pie-chart3",
                "url": "SharedServices/Control/Report/AnalyticsReport",
                "externalSystemID": 3
            }
        ]
    }
]